// extracted by mini-css-extract-plugin
module.exports = {"footer":"PromotionFooter_footer__1R0Gz","footerText":"PromotionFooter_footerText__2OnTS","footerLogo":"PromotionFooter_footerLogo__1bdsb"};